import React from 'react';
import { BODY_TEXT_1, EMPTY_IMAGE, HEADING_TEXT_1 } from '../utilities/generatedClasses';

const EmptyState = (props) => {
  const { title, body1, body2 } = props;

  return (
    <div className="recommendations-empty-data">
      <div style={{ width: '269px', height: '196px' }} className={EMPTY_IMAGE} />
      <label className={HEADING_TEXT_1} style={{ textAlign: 'center', marginTop: '24px' }}>{title}</label>
      <label className={BODY_TEXT_1} style={{ textAlign: 'center', margin: '0 6rem' }}>{body1}</label>
      {body2
                && <label className={BODY_TEXT_1} style={{ textAlign: 'center' }}>{body2}</label>

            }

    </div>
  );
};

export default EmptyState;
